import {satGlobals} from "../../../../../sat/helper/sat-globals";
import axios from 'axios';
import {useResultPageStore} from "../stores/ResultPageStore";
import {JOB_STATE_COMPLETE, JOB_STATE_UPLOADING, JOB_STATE_UPLOADING_COMPLETE} from "../const/job.const";
import OutputSelectionManager from "../manager/OutputSelectionManager";
import Analytics from "./Analytics";

let selectedOutputs = [];
let selectedJob = null;
function getFilenameFromOutput(output) {
    let lastSlashIndex=output.uri.lastIndexOf('/')
    return output.uri.substring(lastSlashIndex+1)
}

function _getFiles(accessToken) {
    let store = useResultPageStore();
    /*
    var data = {
        url: rsUrl,
        data: {
            oauthToken: accessToken,
        },
    };

     */
    let payload = [];

    selectedOutputs.forEach((output) => {
        payload.push( {
            id: output.id,
            url: output.uri,
            filename: getFilenameFromOutput(output),
        })
    });

    for (const uploadItem of payload) {
        let output =  store.getOutputById(selectedJob.id, uploadItem.id);
        output.status = 'uploading-init';
    }

    return payload;
}

class DropboxSaver {

    listener = false;

    constructor() {
    }

    async uploadJob(job) {
        Analytics.send('result_dropbox', 'upload_job', job);

        selectedOutputs = job.apiJob.output;
        selectedJob = job;

        selectedJob.state = JOB_STATE_UPLOADING;
        selectedJob.uploadTo = 'dropbox';
        
        this._startDropboxFlow();
    }

    async uploadSelectedOutputs(job) {
        Analytics.send('result_dropbox', 'upload_selected_outputs', job);

        selectedOutputs = OutputSelectionManager.getSelectedOutputs(job);
        selectedJob = job;

        selectedJob.state = JOB_STATE_UPLOADING;
        selectedJob.uploadTo = 'dropbox';

        this._startDropboxFlow();
    }

    async _startDropboxFlow() {
        let that = this;
        (function () {
            var s = document.createElement('script');
            s.type = 'text/javascript';
            s.setAttribute('data-app-key', window.sat.dropboxKey);
            s.src = 'https://www.dropbox.com/static/api/2/dropins.js';
            s.id = 'dropboxjs';
            s.onload = that._onDropboxLoaded;
            let x = document.getElementsByTagName('script')[0];
            x.parentNode.insertBefore(s, x);
        })();
    }

    async _onDropboxLoaded() {
        const files = _getFiles();

        var options = {
            files,

            // Success is called once all files have been successfully added to the user's
            // Dropbox, although they may not have synced to the user's devices yet.
            success: function () {
                // Indicate to the user that the files have been saved.
                Analytics.send('result_dropbox', 'upload_done');
                selectedJob.state = JOB_STATE_UPLOADING_COMPLETE;

                let store = useResultPageStore();
                for (const uploadItem of files) {
                    let output =  store.getOutputById(selectedJob.id, uploadItem.id);
                    output.status = 'uploaded';
                }
            },

            // Progress is called periodically to update the application on the progress
            // of the user's downloads. The value passed to this callback is a float
            // between 0 and 1. The progress callback is guaranteed to be called at least
            // once with the value 1.
            progress: function (progress) {},

            // Cancel is called if the user presses the Cancel button or closes the Saver.
            cancel: function () {
                Analytics.send('result_dropbox', 'upload_cancelled');
                selectedJob.state = JOB_STATE_COMPLETE;
            },

            // Error is called in the event of an unexpected response from the server
            // hosting the files, such as not being able to find a file. This callback is
            // also called if there is an error on Dropbox or if the user is over quota.
            error: function (errorMessage) {}
        };
        window.Dropbox.save(options);
    }
}

export default new DropboxSaver()